import React, { useEffect, useState } from "react"
import './App.css'
import { BrowserRouter as Router, Routes, Route, useLocation } from "react-router-dom"
import routes from "./routes/routes"
//bootstrap css
import 'bootstrap/dist/css/bootstrap.min.css'
//bootstrap js
import 'bootstrap/dist/js/bootstrap.bundle.min.js'
//slick carousel css
import "slick-carousel/slick/slick.css"
import "slick-carousel/slick/slick-theme.css"
//toastify css
import 'react-toastify/dist/ReactToastify.css'
import ScrollToTop from "../src/commonComponents/ScrollToTop/ScrollToTop"
import "../src/assets/css/NavigationBar/NavigationBar.css"
import "../src/assets/css/Footer/Footer.css"
import "../src/assets/css/HomePage/HomePage.css"
import "../src/assets/css/Media/Media.css"
import "../src/assets/css/CompanyModule/CompanyModule.css"
import "../src/assets/css/Products/Products.css"
import "../src/assets/css/ServiceModule/ServiceModule.css"
import "../src/assets/css/KnowledgeCenterModule/KnowledgeCenterModule.css"
import "../src/assets/css/FeasibilityModule/FeasibilityModule.css"
import { Helmet, HelmetProvider } from 'react-helmet-async';
import axios from "axios"


const live = "" //live
const staging = "/deltaspharma2"



const App = () => {
  const [page, setPage] = useState({});
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const location = useLocation();

  //get meta title,description from cms, api integration
  const apiUrl = process.env.REACT_APP_API_BASE_URL;
  const metaTagManagementEndPoint = `/fetch_meta_tag?page_name=`;


  const fetchMetaTagManagement = (pageName) => {
    const metaTagManagementUrl = `${apiUrl}${metaTagManagementEndPoint}${encodeURIComponent(pageName)}`;
    axios
      .get(metaTagManagementUrl)
      .then((res) => {
        if (res.data.status === 0 || res.data.message === "No records found") {
          setPage([]);
        } else {
          setPage(res.data.data[0]);
          // console.log("ressss", page)
        }
        setLoading(false);
      })
      .catch((error) => {
        setError("Error fetching private labels data.");
        setLoading(false);
      })
  };

  useEffect(() => {
    const currentRoute = routes.find((route) => route.path === location.pathname);
    // console.log("route",currentRoute)
    if (currentRoute) {
      const pageName = currentRoute.name;
      fetchMetaTagManagement(pageName);
    }
  }, [location.pathname]);

  return (
    <>
      <HelmetProvider>
        <Helmet>
          <title>{page.page_title || "Default Title"}</title>
          {page.meta_title && <meta name="title" content={page.meta_title} />}
          {page.meta_description && <meta name="description" content={page.meta_description} />}
        </Helmet>
        {/* <Router */}
        {/* > */}
        <ScrollToTop />
        <Routes >
          {routes.map((route) => {
            return (
              <Route key={route.name} path={route.path} exact={route.exact} name={route.name} element={<route.element />}
              />
            );
          })}
        </Routes>
        {/* </Router > */}
      </HelmetProvider>
    </>
  );
}

// export default App

const Root = () => (
  <Router basename={live}>
    <App />
  </Router>
);

export default Root;

